import { Action } from '@ngrx/store';

export const SUCCESS = '[Alert] Success';
export const WARNING = '[Alert] Warning';
export const DANGER =  '[Alert] Danger';
export const CLOSE =   '[Alert] Close';
export const REMOVE =  '[Alert] Remove';

export class SuccessAction implements Action {
  readonly type = SUCCESS;

  constructor(public payload: string) { }
}

export class WarningAction implements Action {
  readonly type = WARNING;

  constructor(public payload: string) { }
}

export class DangerAction implements Action {
  readonly type = DANGER;

  constructor(public payload: string) { }
}

export class CloseAction implements Action {
  readonly type = CLOSE;

  constructor(public payload: number) { }
}

export class RemoveAction implements Action {
  readonly type = REMOVE;
}


export type Actions
  = SuccessAction | WarningAction | DangerAction | CloseAction | RemoveAction;



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/alert/alert.actions.ts